<div class="bg-violet m-0">
  <div class="container grid" style="margin-top: 120px">
    <div class="row text-center piattaforma-row">
      <div class="neutral-00 mb-3 desc-title">
        La nostra piattaforma di e-learning per le scuole
      </div>
      <p class="neutral-00 mt-3 title-desc" style="text-align: center">
        Scopri le funzionalità della nostra piattaforma, per un semplice accesso
        alle nostre risorse di didattica digitale e per monitorare i progressi
        della tua classe.
      </p>
      <div class="col-12 text-center mt-5">
        <button class="btn-lightblue progetto-btn" (click)="redirectToApp()">
          <span class="button-txt">Prova Easycode</span>
        </button>
      </div>
    </div>
    <div class="row text-center p-2 p-xl-5">
      <div class="container-images col-12 d-none d-lg-block">
        <img src="../../../assets/img/Superiori.svg" class="superiori_img" alt="scuole superiori" />
        <img
          src="../../../assets/img/Elementari.svg"
          class="elementari_img"
          style="z-index: 2"
          alt="scuole elementari"
         
        />
        <img
          src="../../../assets/img/Medie.svg"
          class="medie_img"
          alt="scuole medie"
         
        />
      </div>

      <div class="container-images_md col-12 d-none d-md-block d-lg-none">
        <img
          src="../../../assets/img/Elementari.svg"
          class="elementari_img_sm"
          style="z-index: 0"
          alt="scuole elementari"
         
        />
        <img
          src="../../../assets/img/medie_sm.svg"
          class="medie_img_sm"
          style="z-index: 1"
          alt="scuole medie"
         
        />
        <img
          src="../../../assets/img/Superiori_sm.svg"
          class="superiori_img_sm"
          style="z-index: 2"
          alt="scuole Superiori"
         
        />
      </div>

      <div class="container-images_sm col-12 d-block d-md-none">
        <img
          src="../../../assets/img/Elementari.svg"
          class="elementari_img_sm"
          style="width: 100%; z-index: 0"
          alt="scuole elementari"
         
        />
        <img
          src="../../../assets/img/medie_sm.svg"
          class="medie_img_sm"
          style="z-index: 1"
          alt="scuole medie"
         
        />
        <img
          src="../../../assets/img/Superiori_sm.svg"
          class="superiori_img_sm"
          style="z-index: 2"
          alt="scuole Superiori"
         
        />
      </div>
    </div>
  </div>
</div>

<div class="m-0 bg-w neutral-00 mb-5 p-5" style="z-index: 5">
  <div class="container grid">
    <div class="row text-center">
      <h3 class="blue-50 w-700 mb-2">Easycode è una piattaforma</h3>
    </div>

    <div class="row mt-5">
      <div class="col-xl-4 d-flex justify-content-center">
        <img
          src="../../../assets/img/interattiva_color.svg"
          class="ec-pt mb-5 mb-xl-0"
          alt="piattaforma interattiva"
         
        />
      </div>
      <div class="col-xl-4 d-flex justify-content-center">
        <img
          src="../../../assets/img/coll_color.svg"
          class="ec-pt my-5 my-xl-0"
          alt="piattaforma interattiva"
         
        />
      </div>
      <div class="col-xl-4 d-flex justify-content-center">
        <img
          src="../../../assets/img/part_color.svg"
          class="ec-pt mt-5 mt-xl-0"
          alt="piattaforma interattiva"
         
        />
      </div>
    </div>
  </div>
</div>

<div class="mt-5 piattaforma-bck">
  <div class="row text-center m-0 desctiption-wa">
    <p class="title-desc">
      La nostra piattaforma di e-learning raccoglie le nostre
      <b>videolezioni</b>:<br />
      corsi di <b>coding</b>, robotica educativa e programmazione realizzate dai
      nostri<br />
      educatori digitali.
    </p>
  </div>
</div>

<div class="container grid offerta">
  <div class="row text-center m-0 mt-5">
    <h2 class="blue-50 bold mb-4 w-700">Obiettivi della piattaforma</h2>
  </div>
</div>

<div class="container grid mt-5 mb-5 p-3">
  <div class="row mt-0 p-0">
    <div class="col-12 cards-col">
      <div class="school-card p-4">
        <img
          src="assets/img/icons/School.svg"
          alt="pensiero computazionale"
         
        />
        <p class="title-desc" style="text-align: start">
          Insegnare il coding e il
          <span style="color: rgba(120, 60, 215, 1); font-weight: bold"
            >pensiero computazionale</span
          >
          nella scuola, fornendo accesso illimitato alle videolezioni sulla
          piattaforma Easycode, anche al di fuori delle ore scolastiche.
        </p>
      </div>
      <div class="school-card p-4">
        <img
          src="../../../assets/img/icons/person-graduate.svg"
          alt="pensiero computazionale"
         
        />
        <p class="title-desc" style="text-align: start">
          Offrire un'offerta formativa differenziata in base alle fasce d'età,
          accompagnando la crescita dei bambini dalla scuola primaria fino alla
          scuola secondaria di secondo grado.
        </p>
      </div>
      <div class="school-card p-4">
        <img
          src="../../../assets/img/icons/book.svg"
          alt="insegnamento del coding"
         
        />
        <p class="title-desc" style="text-align: start">
          Integrare l'insegnamento del
          <span style="color: rgba(120, 60, 215, 1); font-weight: bold"
            >coding</span
          >
          in tutte le materie scolastiche.
        </p>
      </div>
      <div class="school-card p-4">
        <img
          src="../../../assets/img/icons/degree.svg"
          alt="insegnamento del coding"
         
        />
        <p class="title-desc" style="text-align: start">
          Coinvolgere gli studenti attraverso la
          <span style="color: rgba(120, 60, 215, 1); font-weight: bold"
            >gamification</span
          >: imparare divertendosi è fondamentale per noi di Easycode, e
          l'esperienza ludica stimola gli studenti a mettersi veramente…in
          gioco.
        </p>
      </div>
      <div class="school-card p-4">
        <img
          src="../../../assets/img/Aggiungi.svg"
          alt="insegnamento del coding"
         
        />
        <p class="title-desc" style="text-align: start">
          Promuovere l’inclusione, grazie a contenuti appositamente pensati per
          studenti con difficoltà nell’apprendimento
        </p>
      </div>
    </div>
  </div>
</div>

<div class="bg-violet m-0">
  <div class="container grid">
    <div class="row text-center piattaforma-row">
      <h2 class="neutral-00 bold mb-3 w-700">
        Pensata anche per lo staff scolastico
      </h2>
      <p class="neutral-00 mt-3 title-desc">
        Una piattaforma ad uso esclusivo delle scuole, pensata non solo per gli
        studenti <br />
        ma anche per dirigenti e staff scolastico. Se sei un’insegnante, puoi
        monitorare l’andamento dei corsi <br />
        svolti in aula e a casa in maniera facile e veloce.
      </p>
    </div>
    <div>
      <div class="row container-staff d-none d-md-block">
        <div class="col-12 text-center img-site">
          <img
            src="../../../assets/img/site.svg"
            alt="corsi coding"
           
          />
        </div>
      </div>

      <section class="d-block d-md-none">
        <div class="row container-staff-sm">
          <div class="col-12 text-center img-site" style="width: 100%">
            <img
              src="../../../assets/img/site.svg"
              style="width: 100%"
              alt="corsi coding"
             
            />
          </div>
        </div>
      </section>
    </div>
  </div>
</div>

<div class="bg-w m-0" style="z-index: 9">
  <div class="container grid">
    <div class="row p-2 p-xl-5">
      <h2 class="blue-50 bold mt-3 w-700 text-center">
        Funzionalità principali della nostra piattaforma
      </h2>

      <p class="mb-3 title-desc">
        La nostra piattaforma di didattica digitale è uno strumento utile per la
        formazione dei docenti e un valido supporto per l’insegnamento del
        coding. Con Easycode, il personale scolastico ha accesso a diversi corsi
        tematici che possono essere sfruttati in classe, ampliando il bagaglio
        tecnico degli studenti e prepararli al futuro.
      </p>
    </div>
    <div class="col-12 text-center">
      <button class="btn-lightblue progetto-btn" (click)="redirectToApp()">
        <span class="button-txt">ISCRIVITI AL PROGETTO</span>
      </button>
    </div>
    <!--display small-->
    <section class="d-block d-lg-none" style="margin-bottom: 80px;">
      <div class="row p-2 p-xl-5 pointer" #myElement>
        <div
          class="col-12 text-left mb-3 mb-lg-0"
          style="padding-top: 40px"
          *ngIf="slideSelected == 1"
        >
          <p class="title-desc text-center">
            <span class="w-700">Dashboard</span> <br />
            Monitora con facilità i progressi nei corsi, i corsi per scuola
            primaria e secondaria aggiunti di recente, quanti alunni sono
            iscritti al programma Easycode, i loro progressi nel dettaglio e
            altro ancora.
          </p>
        </div>
        <div class="col-12 text-center" *ngIf="slideSelected == 1">
          <img
            src="../../../assets/img/piattaforma_site1.svg"
            style="max-width: 100%"
            alt="piattaforma"
           
          />
        </div>
        <div
          class="col-12 text-left mb-3 mb-lg-0"
          style="padding-top: 40px"
          *ngIf="slideSelected == 2"
        >
          <p class="title-desc text-center">
            <span class="w-700">Classi e studenti</span> <br />
            In queste sezioni puoi vedere i dettagli e delle classi e degli
            studenti della scuola che stanno seguendo i corsi. Inoltre da qui
            puoi verificare e modificare i loro dati.
          </p>
        </div>
        <div class="col-12 text-center" *ngIf="slideSelected == 2">
          <img
            src="../../../assets/img/piattaforma_site2.svg"
            style="max-width: 100%"
            alt="piattaforma"
           
          />
        </div>
        <div
          class="col-12 text-left mb-3 mb-lg-0"
          style="padding-top: 40px"
          *ngIf="slideSelected == 3"
        >
          <p class="title-desc text-center">
            <span class="w-700">Corsi ed educatori</span> <br />
            Qui puoi tenere traccia dei corsi attivati nella scuola e
            dell’avanzamento nel completamento dei corsi dei tuoi alunni.
            Inoltre, puoi vedere gli educatori digitali assegnati a ciascun
            corso.
          </p>
        </div>
        <div class="col-12 text-center" *ngIf="slideSelected == 3">
          <img
            src="../../../assets/img/piattaforma_site3.svg"
            style="max-width: 100%"
            alt="piattaforma"
           
          />
        </div>
        <div
          class="col-12 mb-3 mb-lg-0"
          style="padding-top: 40px"
          *ngIf="slideSelected == 4"
        >
          <p class="title-desc text-center">
            <span class="w-700">Staff</span> <br />
            In questa sezione sono presenti i dettagli dei docenti scolastici e
            le classi a loro assegnate.
          </p>
        </div>
        <div class="row" style="padding-top: 40px;">
          <div class="col pointer-slide">
            <div (click)="changeSlide(1)" class="pointer">
              <img
                src="assets/img/slide-selected.svg" alt="" aria-hidden="true"
                *ngIf="slideSelected == 1"
              />
              <img
                src="assets/img/slide-unselected.svg" alt="" aria-hidden="true"
                *ngIf="slideSelected != 1"
              />
            </div>
            <div (click)="changeSlide(2)" class="pointer">
              <img
                src="assets/img/slide-selected.svg" alt="" aria-hidden="true"
                *ngIf="slideSelected == 2"
              />
              <img
                src="assets/img/slide-unselected.svg" alt="" aria-hidden="true"
                *ngIf="slideSelected != 2"
              />
            </div>
            <div (click)="changeSlide(3)" class="pointer">
              <img
                src="assets/img/slide-selected.svg" alt="" aria-hidden="true"
                *ngIf="slideSelected == 3"
              />
              <img
                src="assets/img/slide-unselected.svg" alt="" aria-hidden="true"
                *ngIf="slideSelected != 3"
              />
            </div>
            <div (click)="changeSlide(4)" class="pointer">
              <img
                src="assets/img/slide-selected.svg" alt="" aria-hidden="true"
                *ngIf="slideSelected == 4"
              />
              <img
                src="assets/img/slide-unselected.svg" alt="" aria-hidden="true"
                *ngIf="slideSelected != 4"
              />
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="row p-2 p-xl-5 d-none d-lg-block">
      <div class="container-functions">
        <div class="container-left">
          <div class="col-12 mb-3 mb-lg-0">
            <p class="title-desc" style="text-align: left">
              <span class="w-700">Dashboard</span> <br />
              Monitora con facilità i progressi nei corsi, i corsi per scuola
              primaria e secondaria aggiunti di recente, quanti alunni sono
              iscritti al programma Easycode, i loro progressi nel dettaglio e
              altro ancora.
            </p>
          </div>
          <div class="col-12 text-left mb-3 mb-lg-0">
            <p class="title-desc" style="text-align: left">
              <span class="w-700">Classi e studenti</span> <br />
              In queste sezioni puoi vedere i dettagli e delle classi e degli
              studenti della scuola che stanno seguendo i corsi. Inoltre da qui
              puoi verificare e modificare i loro dati.
            </p>
          </div>
          <div class="col-12 text-left mb-3 mb-lg-0">
            <p class="title-desc" style="text-align: left">
              <span class="w-700">Corsi ed Educatori</span> <br />
              Qui puoi tenere traccia dei corsi attivati nella scuola e
              dell’avanzamento nel completamento dei corsi dei tuoi alunni.
              Inoltre, puoi vedere gli educatori digitali assegnati a ciascun
              corso.
            </p>
          </div>
          <div class="col-12 text-left mb-3 mb-lg-0">
            <p class="title-desc" style="text-align: left">
              <span class="w-700">Staff</span> <br />
              In questa sezione sono presenti i dettagli dei docenti scolastici
              e le classi a loro assegnate.
            </p>
          </div>
        </div>
        <div class="container-right">
          <div class="col-12">
            <img
              src="../../../assets/img/piattaforma_site1.svg"
              style="max-width: 100%"
              alt="piattaforma"
             
            />
          </div>
          <div class="col-12">
            <img
              src="../../../assets/img/piattaforma_site2.svg"
              style="max-width: 100%"
              alt="piattaforma"
             
            />
          </div>
          <div class="col-12">
            <img
              src="../../../assets/img/piattaforma_site3.svg"
              style="max-width: 100%"
              alt="piattaforma"
             
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-iscriviti></app-iscriviti>
</div>
